<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('distributors.create')" @invoke-method="invokeMethod($event)" action="openDistributorForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetDistributors(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="distributors" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openDistributorForm(props.item)">
                                <td><img :src="props.item.logo" @error="imageLoadError" style="max-width: 50px; max-height: 50px" /></td>
                                <td>{{ props.item.company }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="distributors"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="distributor_dialog">
                <v-card>
                    <v-form ref="form_distributor">
                        <v-card-title>
                            <span class="headline">{{ distributor.company_id ? $t("lang.edit_distributor") : $t("lang.add_distributor") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeDistributorDialog"
                                :dialog-status="distributor_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="form_distributor" @submit.prevent>
                                <v-container grid-list-form>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-focus="distributor_dialog"
                                                v-model="distributor.company"
                                                :label="`${$t('lang.company')} *`"
                                                :counter="showCounter(distributor.company, 'distributor.company')"
                                                :rules="ifValid('distributor.company')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="distributor.company_id" color="error" @mouseup.left="$refs.delete_distributors.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeDistributorDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveDistributors">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_distributors"
                :heading="$t('lang.delete_distributor')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteDistributors(distributor.company_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openDistributorForm" },
                { title: this.$t("lang.refresh"), action: "dbGetDistributors", params: [true] },
            ],
            headers: [
                { text: "", sortable: false, align: "center", width: "60" },
                { text: this.$t("lang.distributor"), sortable: false },
            ],
            distributor: {},
            filter: {
                search: "",
                company_id: "",
                status: "1",
            },
            distributor_dialog: false,
            dbGetDistributors: _.debounce(this.getDistributors, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchDistributors", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.distributors) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchDistributors({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.distributors) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.distributors.distributors_filter,
            page: (state) => state.distributors.page,
            rules_distributors: (state) => state.distributors.rules_distributors,
            distributor_status_options: (state) => state.settings.distributor_status_options,
            distributors: (state) => state.distributors.distributors,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDistributors", "saveDistributor", "deleteDistributor"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openDistributorForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "distributor", params: { id: item.company_id } });
            } else {
                this.$router.push({ name: "distributor" });
            }
        },
        saveDistributors() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_distributor")) {
                    let body = this.prepForm(this.distributor, this.rules_distributors);

                    this.saveDistributor({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.$router.push({ name: "distributor", params: { id: data.distributor.company_id } });
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteDistributors(id = null) {
            this.deleteDistributor({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getDistributors();
                    this.closeDistributorDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeDistributorDialog() {
            this.distributor_dialog = false;
            this.$refs.delete_distributors.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        imageLoadError(event) {
            event.target.src = AppConfig.defaultProfileLogo;
        },
        getDistributors(pg_refresh = false) {
            this.startLoader();

            this.fetchDistributors({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.distributor_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
